import { render, staticRenderFns } from "./radarChart.vue?vue&type=template&id=66017880&scoped=true&"
import script from "./radarChart.vue?vue&type=script&lang=js&"
export * from "./radarChart.vue?vue&type=script&lang=js&"
import style0 from "./radarChart.vue?vue&type=style&index=0&id=66017880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66017880",
  null
  
)

export default component.exports